import { render } from "./DataUsagesMaster.vue?vue&type=template&id=5e6c502c&scoped=true"
import script from "./DataUsagesMaster.vue?vue&type=script&lang=js"
export * from "./DataUsagesMaster.vue?vue&type=script&lang=js"

import "./DataUsagesMaster.vue?vue&type=style&index=0&id=5e6c502c&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6c502c"]])

export default __exports__